<template>
            <ais-instant-search
                class="search-component"
                :search-client="searchClient"
                :routing="routing"
                index-name="recommendations:most_loved_reviews_count:desc" >

                <!-- Scope to this city (Meilisearch filter syntax) -->
                <ais-configure :filters="filters" />
<!--                               :disjunctive-facets-refinements.camel="{ 'category.title': ['Play', 'Eat', 'Sleep'] }" />-->

                <!-- Google Maps -->
                <google-map :city="city"
                            :is-content-blocked="isContentBlocked"
                            @bounds-changed="clearFilter()" />

                <div class="map-sidebar">

                    <!-- Filters Slider  -->
                    <filters :city="city"
                             :is-content-blocked="isContentBlocked"" />

                    <mobile-map-controls></mobile-map-controls>

                    <ais-infinite-hits :transform-items="transformItems">
                        <template v-slot="{ items, refinePrevious, refineNext, isLastPage, sendEvent }">

                            <div class="map-list wrapper">

                                <!-- Mobile Button -->
                                <div class="mob-map-trigger">
                                    <div id="map-cta" class="map-wrap">
                                        <google-map-button :city="city"></google-map-button>
                                    </div>
                                </div>

                                <div class="map-list-header" :style="mapListHeaderStyle">

                                    <ais-stats>
                                        <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">
                                            <div class="map-count">
                                                <span v-text="nbHits"></span> {{ pluralize('Spot', nbHits) }}
                                            </div>
                                        </template>
                                    </ais-stats>

                                        <!-- Sort By -->
                                        <ais-sort-by :items="availableSortOptions">
                                            <template v-slot="{ items, currentRefinement, refine }">
                                                <div class="map-sort">
                                                    <div class="map-sort-cta">
                                                        Sort by <span v-text="sortOptionsLabels[currentRefinement]"></span>
                                                        <svg class='arrow-down'><use xlink:href="#arrow-down"></use></svg>
                                                    </div>

                                                    <div class="map-sort-dd">
                                                          <span v-for="item in items"
                                                                @click.prevent="refine(item.value)"
                                                                v-text="item.label">
                                                          </span>
                                                    </div>

                                                </div>
                                            </template>
                                        </ais-sort-by>
                                </div>

                                <spot-items :spots="items"></spot-items>

                                <!-- Load More -->
                                <div class="btn-load-more-container" v-if="!isLastPage">
                                    <button class="btn-load-more" @click="refineNext">
                                        Load More
                                    </button>
                                </div>

                            </div>

                        </template>
                    </ais-infinite-hits>

                </div>

            </ais-instant-search>
</template>

<script>

import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import GoogleMap from './Map'
import Helpers from '@/mixins/Helpers'
import Filters from './Filters'
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import MobileMapControls from '@/components/Maps/MobileControls'
import GoogleMapButton from '@/components/Cities/MapButton'
import SpotItems from './SpotItems'

export default {

    mixins: [Helpers,],

    props: ['city', 'spotsOnMyLists', 'isContentBlocked'],

    components: {
        Filters,
        GoogleMap,
        SpotItems,
        GoogleMapButton,
        MobileMapControls,
    },

    data() {
        return {
            mapListHeaderStyle: {
                'margin-top': this.isMobile ? '25px' : '15px',
                'padding-bottom': '15px'
            },
            availableSortOptions: [
                {value: 'recommendations:most_loved_reviews_count:desc', label: 'Most Loved'},
                {value: 'recommendations:published_at:desc', label: 'New'},
                {value: 'recommendations:name:asc', label: 'A-Z'},
                {value: 'recommendations:price:asc', label: 'Price'},
            ],
            sortOptionsLabels: {
                'recommendations:most_loved_reviews_count:desc': 'Most Loved',
                'recommendations:published_at:desc': 'New',
                'recommendations:name:asc': 'A-Z',
                'recommendations:price:asc': 'Price',
            },
            filters: `city.title = "${this.city.title}"`,
            searchClient: instantMeiliSearch(
                (window.config && window.config.search && window.config.search.meili_host) || (window.location.origin + '/meili'),
                (window.config && window.config.search && window.config.search.meili_key) || 'proxy',
                { keepZeroFacets: true }
            ).searchClient,
            routing: {
                router: historyRouter({
                    writeDelay: 400,
                    parseURL({qsModule, location}) {


                        let indexState = {
                            refinementList: {},
                            toggle: {},
                            geoSearch: {},
                        }

                        const searchParams = new URLSearchParams(location.search);

                        // Sort
                        if (searchParams.has('sort-by')) {
                            indexState['sortBy'] = searchParams.get('sort-by')
                        }

                        // Geo Search
                        if (searchParams.has('place')) {
                            indexState.geoSearch['boundingBox'] = searchParams.get('place')
                        }

                        // Verified
                        if (searchParams.has('verified')) {
                            indexState.toggle['is_verified'] = true
                        }

                        // Categories
                        if (searchParams.has('category')) {
                            indexState.refinementList['category.title'] = searchParams.get('category').split(',')
                        }

                        // Price
                        if (searchParams.has('price')) {
                            indexState.refinementList['price'] = searchParams.get('price').split(',')
                        }

                        // Neighborhoods
                        if (searchParams.has('neighborhood')) {
                            indexState.refinementList['neighborhood.title'] = searchParams.get('neighborhood').split(',')
                        }

                        // Eat Options
                        if (searchParams.has('eat')) {
                            indexState.refinementList['eat_options'] = searchParams.get('eat').split(',')
                        }

                        // Eat Options
                        if (searchParams.has('play')) {
                            indexState.refinementList['play_options'] = searchParams.get('play').split(',')
                        }

                        // Tags
                        if (searchParams.has('tags')) {
                            indexState.refinementList['tags'] = searchParams.get('tags').split(',')
                        }

                        return indexState
                    },
                    createURL({qsModule, location, routeState}) {
                        const {origin, pathname, hash} = location;
                        const indexState = routeState || {};

                        let url = '?'

                        // Sort
                        if (indexState.sortBy) {
                            url += `sort-by=${indexState.sortBy}&`
                        }

                        // Refinaments
                        if (indexState.refinementList) {
                            let refinaments = indexState.refinementList

                            // Categories
                            if (refinaments.hasOwnProperty('category.title') && refinaments['category.title'].length) {
                                url += 'category=' + refinaments['category.title'].toString() + '&'
                            }

                            // Price
                            if (refinaments.hasOwnProperty('price') && refinaments['price'].length) {
                                url += 'price=' + refinaments['price'] + '&'
                            }

                            // Neighborhoods
                            if (refinaments.hasOwnProperty('neighborhood.title') && refinaments['neighborhood.title'].length) {
                                url += 'neighborhood=' + refinaments['neighborhood.title'].toString() + '&'
                            }

                            // Eat Options
                            if (refinaments.hasOwnProperty('eat_options') && refinaments['eat_options'].length) {
                                url += 'eat=' + refinaments['eat_options'].toString() + '&'
                            }

                            // Play Options
                            if (refinaments.hasOwnProperty('play_options') && refinaments['play_options'].length) {
                                url += 'play=' + refinaments['play_options'].toString() + '&'
                            }

                            // Tags
                            if (refinaments.hasOwnProperty('tags') && refinaments['tags'].length) {
                                url += 'tags=' + refinaments['tags'].toString() + '&'
                            }

                        }

                        // Toggle
                        if (indexState.toggle && indexState.toggle.hasOwnProperty('is_verified')) {
                            url += 'verified&'
                        }

                        // GeoSearch
                        if (indexState.geoSearch && indexState.geoSearch.hasOwnProperty('boundingBox')) {
                            url += `place=${indexState.geoSearch.boundingBox}&`
                        }


                        // Url
                        return `${origin}${pathname}${url.slice(0, -1)}`;
                    },
                }),
                stateMapping: singleIndexMapping('recommendations:most_loved_reviews_count:desc'),
            },
        };
    },

    methods: {
        clearFilter() {
            this.filters = ''
        },

        transformItems(items) {
            if (this.isContentBlocked) {
                return _.take(items, 4)
            }
            return items
        }
    }
};
</script>
